module.exports = "<div class=\"{{ vm.name }}\">\n  <div class=\"btn-group\" uib-dropdown is-open=\"status.isopen\">\n   <button id=\"single-button\" type=\"button\" class=\"btn btn-link\" uib-dropdown-toggle ng-disabled=\"disabled\">\n   {{vm.dropText | translate}}<span class=\"st-icon-chevron-down st-icon-chevron-down-sm-button\"></span>\n   </button>\n   <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\">\n      <li ng-repeat=\"item in vm.items\">\n          <a href=\"\" ng-click=\"vm.toggleDropdown(item)\">{{item.name | translate}}</a>\n      </li>\n   </ul>\n </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/stSelect/stSelect.html
// module id = 37
// module chunks = 0